export const config: IAppConfig =
  typeof TAL === "undefined"
    ? /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
      typeof (window as any).__STORYBOOK_ADDONS === "undefined"
      ? /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
        (null as any)
      : {}
    : TAL.config;

if (config == null) {
  throw new Error("App config is missing");
}
export const appName = TAL.config.appName || "authcallback";
